<template>
	<div class="footer_wrap">
		<div class="ft_box1">
			<div class="ftbx_con">
				<img class="ft_logo" src="@/images/logo2.png">
				<div class="nav_list flex1" v-show="headList.length">
					<ul v-for="item in headList" :key="item.id" v-if="item.title!='首页'">
						<p>{{item.title}}</p>
						<li v-for="(item2,index2) in item.son" :key="item2.id" @click="navClick(item,item2,index2)">{{item2.title}}</li>
					</ul>
					<div class="gzh">
						<img :src="staticImg+comInfo.image">
						<p>关注微信公众号</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			navList: [],
            comInfo:{},
            staticImg: this.$staticImg,
		};
	},
	computed: {
		...mapState(["headList"]),
	},
    created(){
        this.abouts();
    },
	methods: {
        async abouts() {
			const res = await this.$api.abouts();
			if (res.code == 1) {
				this.comInfo = res.data;
			}
		},
		navClick(item, item2, index2) {
			if (item2.name) {
				this.$router.push(item2.name);
			} else {
                if(item.title=='关于集团'){
                    this.$router.push('/aboutUs?sort=' + (index2 + 1));
                }else{
                    this.$router.push(item.name + '?sort=' + (index2 + 1));
                }
			}
		},
	}
}
</script>

<style lang="scss">
.footer_wrap {
	.ft_box1 {
		background-color: #e1e2e6;
		height: 440px;
		padding-top: 45px;
		.ftbx_con {
			width: 1440px;
			margin: 0 auto;
			.ft_logo {
				width: 300px;
			}
			.nav_list {
				align-items: flex-start;
				margin-top: 45px;
				ul {
					p {
						font-size: 22px;
						font-weight: bold;
						margin-bottom: 10px;
					}
					li {
						font-size: 16px;
						padding: 8px 0;
						cursor: pointer;
						&:hover {
							color: #00409a;
						}
					}
				}
				.gzh {
					p {
						text-align: center;
						font-size: 18px;
						margin-top: 5px;
					}
                    img{
                        width: 145px;
                        height: 145px;
                    }
				}
			}
		}
	}
	@media screen and (max-width: 1600px) {
		.ft_box1 {
			height: 400px;
			.ftbx_con {
				width: 1200px;
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.ft_box1 {
			height: 400px;
			.ftbx_con {
				width: 1100px;
			}
		}
	}
    @media screen and (max-width: 1300px) {
		.ft_box1 {
			height: 400px;
			.ftbx_con {
				width: 1000px;
			}
		}
	}
}
</style>